export default __webpack_public_path__ + "static/media/diamond-color-4@2x.f276bcbb.png";